module.exports = __webpack_public_path__ + "img/未标题.ae8ecc2d.jpg";